import React from "react";
import { css, useTheme } from "@emotion/react";
import { BreakpointSize, isDown } from "theme/breakpoints";
import useBreakpoint from "core/hooks/useBreakpoint";

type Props = {
    children: React.ReactNode,
    className?: string,
    chevronDirection: "left" | "right",
    isChevronYCentre?: boolean,
    leftAndRight?: number,
    size?: number,
    imageHeight?: number,
    topOffset?: number,
    breakpointForBottomChevrons?: BreakpointSize,
};

const ChevronContainer: React.FC<Props> = ({
    children,
    className,
    chevronDirection,
    isChevronYCentre = false,
    leftAndRight = 72,
    size = 30,
    imageHeight = 0,
    topOffset = 0,
    breakpointForBottomChevrons = "md",
}) => {
    const { breakpoint } = useBreakpoint();
    const theme = useTheme();
    const imageYCentre = imageHeight / 2 - size / 2;

    const style = css`
        position: absolute;

        // / 2: Middle of the image
        ${chevronDirection === "left" ? css`
            left: -${leftAndRight}px;
            top: ${imageYCentre + (isChevronYCentre ? 0 : topOffset)}px;
        ` : css`
            right: -${leftAndRight}px;
            top: ${imageYCentre + (isChevronYCentre ? 0 : topOffset)}px;
        `}

        // 27: margin-top of ImageText
        ${isDown(breakpoint, breakpointForBottomChevrons) && css`
            ${theme.breakpoints.only("md")} {
                ${chevronDirection === "left" ? css`
                    left: -${leftAndRight}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 27 + topOffset)}px;
                ` : css`
                    right: -${leftAndRight}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 27 + topOffset)}px;
                `}
            }

            // 28: margin-top of ImageText
            ${theme.breakpoints.only("sm")} {
                ${chevronDirection === "left" ? css`
                    left: -${leftAndRight}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 28 + topOffset)}px;
                ` : css`
                    right: -${leftAndRight}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 28 + topOffset)}px;
                `}
            }

            // 28: margin-top of ImageText, 7: Set the detail position

            ${theme.breakpoints.down("xs")} {
                ${chevronDirection === "left" ? css`
                    left: ${isChevronYCentre ? -leftAndRight : 0}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 28 + topOffset)}px;
                ` : css`
                    right: ${isChevronYCentre ? -leftAndRight : 0}px;
                    top: ${isChevronYCentre ? imageYCentre : (imageHeight + 28 + topOffset)}px;
                `}
            }`
        }
    `;

    return (
        <div css={style} className={className}>
            {children}
        </div>
    );
};

export default ChevronContainer;
